import { cn } from '@/shared/lib/cn';

export type SkeletonProps = {
  variant?: 'text' | 'card' | 'table' | 'circle';
  rows?: number;
  className?: string;
};

function Bone({ className }: { className?: string }) {
  return (
    <div
      className={cn('animate-pulse rounded-control bg-border/80', className)}
      aria-hidden
    />
  );
}

export function Skeleton({ variant = 'text', rows = 3, className }: SkeletonProps) {
  if (variant === 'circle') {
    return <Bone className={cn('size-10 rounded-full', className)} />;
  }

  if (variant === 'card') {
    return (
      <div className={cn('space-y-3 rounded-card border border-border p-4', className)}>
        <Bone className="h-4 w-1/3" />
        <Bone className="h-3 w-full" />
        <Bone className="h-3 w-5/6" />
      </div>
    );
  }

  if (variant === 'table') {
    return (
      <div className={cn('space-y-2', className)}>
        <Bone className="h-8 w-full" />
        {Array.from({ length: rows }, (_, i) => (
          <Bone key={i} className="h-10 w-full" />
        ))}
      </div>
    );
  }

  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: rows }, (_, i) => (
        <Bone key={i} className={cn('h-3', i === rows - 1 ? 'w-2/3' : 'w-full')} />
      ))}
    </div>
  );
}
